export const ActionTypes = {
  GET_ALL_MALLS: 'GET_ALL_MALLS',
  GET_ALL_MALLS_USERS: 'GET_ALL_MALLS_USERS',
  GET_ALL_STORES: 'GET_ALL_STORES',
  GET_ALL_STORES_GROUP: 'GET_ALL_STORES_GROUP',
};
